import {style, cssRule} from 'typestyle'

export const main = style({
    display: 'block',
    color: '#333',
    fontSize: '12px',
    maxWidth: '480px',
    margin: '0 auto',
    boxSizing: 'border-box',
    position: 'relative',
    minHeight: '100vh',
    backgroundColor: '#f7f7f7'
})

cssRule('html, body', {
    height: '100%',
    width: '100%',
    padding: 0,
    margin: 0
})

cssRule('.lazy-load-image-background span', {
    minWidth: '1px',
    minHeight: '1px'
})

cssRule('#lazy-loader-component', {
    width: '100%',
    height: '100%'
})

cssRule('#lazy-loader-component span', {
    minWidth: '1px',
    minHeight: '1px'
})



// WEBPACK FOOTER //
// ./src/styles/App.style.ts